module.exports = __webpack_public_path__ + "img/gamevy.6880e640.svg";